import { render, staticRenderFns } from "./materialPreviewer.vue?vue&type=template&id=b76e26ce&scoped=true"
import script from "./materialPreviewer.vue?vue&type=script&lang=js"
export * from "./materialPreviewer.vue?vue&type=script&lang=js"
import style0 from "./materialPreviewer.vue?vue&type=style&index=0&id=b76e26ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e26ce",
  null
  
)

export default component.exports